<div *ngIf="companies.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome Fantasia
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                E-mail
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                CNPJ
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'company.update']"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let company of companies">
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                <app-status-switch
                  [active]="company.active"
                  [itemName]="'empresa ' + company.name"
                  [enablePermissions]="[ERoleAdminString.Admin, 'company.enable']"
                  [disablePermissions]="[ERoleAdminString.Admin, 'company.disable']"
                  (toggle)="toogleEmpresaStatus(company.id!, company.active)"
                ></app-status-switch>
              </td>
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ company.name }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ company.email }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ company.document | mask: '00.000.000/0000-00' }}
              </td>
              <td
                class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'company.update']"
              >
                <a
                  *isAllowed="[ERoleAdminString.Admin, 'company.update']"
                  [routerLink]="'editar/' + company.id"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [attr.aria-label]="'Editar empresa ' + company.name"
                  [title]="'Editar empresa ' + company.name"
                >
                  <lucide-icon name="pencil" [size]="18"></lucide-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="companies.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
